import { z } from "zod";

import { shippingLabelReportBodySchema } from "./shipping-label-report-schema.ts";

export const sendDocsBodySchema = z.object({
	subject: z.string().nullable(),
	toEmails: z.array(z.string()),
	poNumber: z.number(),
	messageBody: z.string(),
	shippingLabelReport: shippingLabelReportBodySchema,
});

export type SendDocsBody = z.infer<typeof sendDocsBodySchema>;

export const sendDocsResponseSchema = z.object({});

export type SendDocsResponse = z.infer<typeof sendDocsResponseSchema>;
